__turbopack_context__.v({
  "badge": "USyGZa_badge",
  "bandHeader": "USyGZa_bandHeader",
  "bandTitle": "USyGZa_bandTitle",
  "billedAnnually": "USyGZa_billedAnnually",
  "billedAnnuallyHidden": "USyGZa_billedAnnuallyHidden",
  "billingStatic": "USyGZa_billingStatic",
  "billingToggle": "USyGZa_billingToggle",
  "bridge": "USyGZa_bridge",
  "bridgeLink": "USyGZa_bridgeLink",
  "card": "USyGZa_card",
  "cardDesc": "USyGZa_cardDesc",
  "cardHighlight": "USyGZa_cardHighlight",
  "cardLinkButton": "USyGZa_cardLinkButton",
  "cardName": "USyGZa_cardName",
  "cardNameRow": "USyGZa_cardNameRow",
  "compareCol": "USyGZa_compareCol",
  "compareColOurs": "USyGZa_compareColOurs",
  "compareGrid": "USyGZa_compareGrid",
  "compareList": "USyGZa_compareList",
  "compareName": "USyGZa_compareName",
  "expertSolo": "USyGZa_expertSolo",
  "feature": "USyGZa_feature",
  "featureDisabled": "USyGZa_featureDisabled",
  "featureIcon": "USyGZa_featureIcon",
  "featureIconDisabled": "USyGZa_featureIconDisabled",
  "features": "USyGZa_features",
  "feeCredit": "USyGZa_feeCredit",
  "frameworkLink": "USyGZa_frameworkLink",
  "grid": "USyGZa_grid",
  "gridTeams": "USyGZa_gridTeams",
  "growthNote": "USyGZa_growthNote",
  "growthNoteLink": "USyGZa_growthNoteLink",
  "header": "USyGZa_header",
  "label": "USyGZa_label",
  "modal": "USyGZa_modal",
  "modalClose": "USyGZa_modalClose",
  "modalError": "USyGZa_modalError",
  "modalForm": "USyGZa_modalForm",
  "modalHeader": "USyGZa_modalHeader",
  "modalIcon": "USyGZa_modalIcon",
  "modalInput": "USyGZa_modalInput",
  "modalOverlay": "USyGZa_modalOverlay",
  "modalSubtitle": "USyGZa_modalSubtitle",
  "modalTerms": "USyGZa_modalTerms",
  "modalTitle": "USyGZa_modalTitle",
  "period": "USyGZa_period",
  "price": "USyGZa_price",
  "priceRow": "USyGZa_priceRow",
  "priceSection": "USyGZa_priceSection",
  "retainerAnchor": "USyGZa_retainerAnchor",
  "retainerCompare": "USyGZa_retainerCompare",
  "sampleLink": "USyGZa_sampleLink",
  "saveBadge": "USyGZa_saveBadge",
  "section": "USyGZa_section",
  "serviceCard": "USyGZa_serviceCard",
  "spin": "USyGZa_spin",
  "spinner": "USyGZa_spinner",
  "staticPill": "USyGZa_staticPill",
  "subtitle": "USyGZa_subtitle",
  "title": "USyGZa_title",
  "togglePill": "USyGZa_togglePill",
  "togglePillActive": "USyGZa_togglePillActive",
  "upgradeNote": "USyGZa_upgradeNote",
});
